<template>
    <div class="notification-container" v-if="notificationCount > 0">
        <span class="notification-circle">
            {{displayedNotificationCount}}
        </span>
    </div>
</template>

<script>
export default {
    name: "NotificationCircle",
    props: {
        notificationCount: {
            type: Number,
            required: true
        }
    },
    computed: {
        displayedNotificationCount(){
            return this.notificationCount < 100 ? this.notificationCount : '99+';
        }
    }
}
</script>

<style scoped lang="scss">
    .notification-container {
        position: relative;
        display: inline-block;

        .notification-circle {
            position: absolute;
            display: inline-block;
            text-align: center;

            height: 23px;
            width: 23px;
            background: #4F99C3;
            border-radius: 50%;
            color: white;
            user-select: none;
            
            &:hover {
                cursor: default;
            }
        }
    }
</style>